$(document).ready(function () {
    function objectToFormData(obj) {
        const formData = new FormData();
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                formData.append(key, obj[key]);
            }
        }
        return formData;
    }

    $(document).on("submit", "#notify--me-form", function (e) {
        e.preventDefault();

        var url = 'https://notify-me.shopify-plugin.devbdd.com/index.php/config/simpanCustomer';
        let data = {
            url_shopify: Shopify.shop,
            nama: $(this).find("input[name='nama']").val(),
            email: $(this).find("input[name='email']").val(),
            no_telp: $(this).find("input[name='no_telp']").val(),
            product_name: $(this).find("input[name='product_name']").val(),
            product_sku: $(this).find("input[name='product_sku']").val(),
            variant_id: $(this).find("input[name='variant_id']").val(),
        }

        const formData = objectToFormData(data);
        $.ajax({
            type: "POST",
            url: url,
            data: formData,
            dataType: "text",
            cache: false,
            contentType: false,
            crossDomain: true,
            processData: false,
            beforeSend: function () {
                $("[data-popup='notify-me']").find(".popup--all-button").text('Pleas Wait...')
                $("[data-popup='notify-me']").find(".popup--all-button").attr('disabled', 'disabled')
            },
            success: function (response) {
                $("[data-popup='notify-me']").find(".popup--all-button").text('Notify me')
                $("[data-popup='notify-me']").find(".popup--all-button").attr('disabled', false);

                console.log(response)

                if (response == 200) {
                    $("[data-popup='notify-me']").find(".popup--all-response").html(`
                        <span class="success-message">Your request has been submitted</span>  
                    `)

                    setTimeout(() => {
                        $("[data-popup='notify-me']").find(".popup--all-close").trigger("click")
                        $("[data-popup='notify-me']").find(".popup--all-response").html("")
                        $("[data-popup='notify-me']").find("input").val("")
                    }, 2000);
                } else {
                    alert("Something wrong, Please refresh page")
                }
            },
            error: function (response) {
                alert('Something wrong, Please refresh page.')
            }
        });
    })
});